import React from 'react';
import {Form} from 'react-form';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import async from 'async';
import Translate from 'translate';

import {FormGroup, Text, Textarea, Checkbox, Select} from 'components/FormElements';
import AutomaticResponseService from 'services/AutomaticResponseService';
import CategoryService from 'services/CategoryService';
import {toggleLoading, toggleAlertError} from 'stores/actions/';
import {required} from 'constants/InputErrors';

class AutomaticResponseEdit extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {},
      categories: []
    };

    this.entityId = props.match.params.id;
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    this.props.toggleLoading( true );

    async.parallel( {
      data: this.getAutomaticResponse.bind( this ),
      categories: this.getCategories
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( !error ) this.setState( results )
    } )
  }

  getCategories( cb ) {
    CategoryService.getCategories( { 'filters[active]': 1 } )
      .then( ( response ) => cb( response.errors, response.data ? response.data.data : [] ) );
  }

  getAutomaticResponse( cb ) {
    if( !this.entityId ) return cb();

    AutomaticResponseService.getAutomaticResponse( this.entityId )
      .then( ( response ) => {
        if( response.errors ) return cb( response.errors );

        if( !response.data.category ) response.data.category = 'all';
        return cb( null, response.data )
      } )
  }

  submitForm( data ) {
    const { history, toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( data );

    toggleLoading( true );

    if( data.category === 'all' ) data.category = '';
    data.category = _.isObject( data.category ) ? data.category.id : data.category;

    const promise = this.entityId ? AutomaticResponseService.updateAutomaticResponse( this.entityId, data ) :
      AutomaticResponseService.saveAutomaticResponse( data );

    promise.then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      return history.push( '/configurations/predefined-answers' )
    } )
  }

  render() {
    return (
      <div className="box box-default">
        <div className="box-header">{this.entityId ? <Translate id="edit"/> : <Translate id="new"/>} <Translate id="predefinedAnswer"/></div>
        <div className="box-body">
          <Form
            defaultValues={this.formData || this.state.data}
            onSubmit={this.submitForm}
            validate={( values ) => {
              return {
                name: required( values.name ),
                description: required( values.description ),
                category: required( values.category ),
                type: required( values.type )
              }
            }}
          >
            {( { submitForm } ) =>
              <form onSubmit={submitForm}>
                <div className="row">
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="name"/></label>
                    <Text field="name" className="form-control"/>
                  </FormGroup>

                  <FormGroup containerClass="col-md-3">
                    <label><Translate id="category"/></label>
                    <Select field="category" className="form-control" placeholder="" labelKey="category"
                            options={[{ id: 'all', category: 'All' }, ...this.state.categories]}/>
                  </FormGroup>

                  <FormGroup containerClass="col-md-3">
                    <label><Translate id="type"/></label>
                    <Select field="type" className="form-control" placeholder=""
                            options={[{ id: 'social', name: 'Social' }, { id: 'chat', name: 'Chat' }]}/>
                  </FormGroup>
                </div>

                <FormGroup>
                  <label><Translate id="description"/></label>
                  <Textarea field="description" className="form-control" rows={5}/>
                </FormGroup>

                <FormGroup containerClass="col-md-2 pl-0">
                  <Checkbox field="active" label={<Translate id="active"/>}/>
                </FormGroup>

                <div className="text-right mt-4">
                  <Link to={`/configurations/predefined-answers`}>
                    <button className="btn btn-outline-secondary px-4 mr-2">
                      <Translate id="cancel"/>
                    </button>
                  </Link>
                  <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                </div>
              </form>
            }
          </Form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( AutomaticResponseEdit );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/predefined-answers/edit/index.js